import { AutogenModelModelPermsAction, AutogenRowModelPermsAction } from "./autogen/AutogenModelModelPermsAction";

export class ModelModelPermsAction extends AutogenModelModelPermsAction<RowModelPermsAction> {
    constructor() {
        super(RowModelPermsAction);
    }
}

export class RowModelPermsAction extends AutogenRowModelPermsAction {
}